import { Link, useNavigate } from "react-router-dom";
import "./BackToDashboard.css";

export default function BackToDashboard({
  to = "/dashboard",
  mode = "link",          
  label = "← Tillbaka till Dashboard",
  className = "",
}) {
  const navigate = useNavigate();

  if (mode === "back") {
    return (
      <button
        type="button"
        onClick={() => navigate(-1)}
        className={`btn-back ${className}`}
      >
        {label}
      </button>
    );
  }

  return (
    <Link to={to} className={`btn-back ${className}`}>
      {label}
    </Link>
  );
}
